import type { RequirementIconName } from '@shared/all/domains/factiiiRequirementOptions';
import type { SectionIconName } from '@shared/utils/helpers/addFactiii/sections';
import type { TemplateIconName } from '@shared/utils/helpers/addFactiii/templates';
import {
  BookOpen,
  Bot,
  Briefcase,
  Building2,
  CalendarClock,
  Camera,
  Clock,
  EyeOff,
  FileText,
  Fingerprint,
  FolderSearch,
  Hash,
  Home,
  Layers,
  Link,
  List,
  ListChecks,
  type LucideIcon,
  MapPin,
  ScrollText,
  Settings2,
  Shield,
  SlidersHorizontal,
  Tag,
  User
} from 'lucide-react';

type IconName = RequirementIconName | TemplateIconName | SectionIconName;

/** Shared copy names its icons; this is the web half of that contract. The
 *  Record keeps it exhaustive — a name added in shared fails to compile here
 *  until it is mapped. */
export const LUCIDE: Record<IconName, LucideIcon> = {
  BookOpen,
  Bot,
  Briefcase,
  Building2,
  CalendarClock,
  Camera,
  Clock,
  EyeOff,
  FileText,
  Fingerprint,
  FolderSearch,
  Hash,
  Home,
  Layers,
  Link,
  List,
  ListChecks,
  MapPin,
  ScrollText,
  Settings2,
  Shield,
  SlidersHorizontal,
  Tag,
  User
};
